export default {
  general: 'General',
  master: 'Master',
  connectedMerchant: 'Connected Merchant'
}
